export default __webpack_public_path__ + "images/icono-normal.09fb8740999048056bb5dc2d48f6f7f9.svg";